import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Link, withRouter } from 'react-router-dom';
import { Icon } from 'antd';
import { Avatar, Col, Row, Table, Select } from 'elements';
import { getHolder } from 'redux/modules/model/holder';
import { holderDetailsSelector } from 'redux/selectors';
import { listDetectables } from 'redux/modules/model/detectable';
import { PageContentTitle } from 'components';
import { withClientId } from 'hocs';
import {
  detectablesListSelector,
  verticalConfigSelector,
  holderIsLoadingSelector
} from 'redux/selectors';
import ContactScheduleAssignments from './components/attendance/contact-schedule-assignments';
import fp from 'lodash/fp';
import moment from 'moment';
import DailyMovementReport from './components/holder-zone-report';
import * as actionsGlobal from '@/redux/new_store_structure/actions';
import './index.scss';
import client from '../../client';

const COMPONENT_CSS_CLASSNAME = 'directory-details';
const bemE = suffix => `${COMPONENT_CSS_CLASSNAME}__${suffix}`;

const columns = [
	{
		title: 'Site',
		dataIndex: 'site',
	},
	{
		title: 'Start',
		dataIndex: 'start'
	},
	{
		title: 'End',
		dataIndex: 'end'
	},
];

function getHistory(data, sitesList) {
	if (data) {
		return data.map((el, i) => ({
			key: i,
			site: sitesList.find(site => el.siteId === site.siteId).description,
			start: `${moment(el.startTime).format('DD-MM-YYYY')}
             - 
            ${moment(el.startTime).format('HH:mm')}`,
			end: `${moment(el.endTime).format('DD-MM-YYYY')}
             - 
            ${moment(el.endTime).format('HH:mm')}`,
		}));
	}
}

class ContactDetails extends Component {
	componentDidMount() {
		const {
			clientId,
			getHolder,
			listDetectables,
			match,
			getVisitsList,
			sitesList,
			getSitesList,
		} = this.props;
		const { clientReference } = match.params;
		getHolder({
			clientId,
			clientReference,
			with: ['metadata', 'detectable-type'],
		});
		listDetectables({ clientId, assignment: clientReference });
		getVisitsList({ clientId, clientReference });
		if (sitesList && sitesList.length === 0) {
			getSitesList({ clientId });
		}
	}

  handleZoneReportChange = (selectedVisit) => {
    const { clientId, match, getHolderZoneReport } = this.props;
    const { clientReference } = match.params;

    const date = new Date(selectedVisit[0]);
    date.setHours(5,0,0,0);
    const startTime = date.toISOString();
    date.setDate(date.getDate() + 1);
    const endTime = date.toISOString();
    const siteId = selectedVisit[1];

    getHolderZoneReport({
      clientId,
      clientReference,
      siteId,
      startTime,
      endTime,
    });
  }

	render() {
		const {
			holder,
			detectablesList,
			match,
			verticalConfig,
			clientId,
			loading,
			loadingList,
			history,
			location: { search },
			visits,
			sitesList,
      holderZoneReport,
      loadingHolderZoneReport
		} = this.props;
		const { clientReference } = match.params;
		const detectables = fp.filter({ assignment: clientReference })(
			detectablesList,
		);
    const visitStartDates = [];
    visits.map(v => {
      const date = new Date(v.startTime).toDateString();
      let i = 0;
      visitStartDates.push({
        value: [date, v.siteId],
        label: v.siteId.concat(' - ', date)
      })
    });
		const metadata =
		holder && holder.metadata
		? Object.keys(holder.metadata).map(key => {
			if(key !== 'DoB' || clientId !== 'gleneagles'){
				const val = holder.metadata[key];
				if (val === null || val === undefined) return null;
				return (
					<div className={bemE('metadata-item')} key={key}>
					<h4 className={bemE('metadata-key')}>{key}</h4>
					<p className={bemE('metadata-value')}>
						{val.toString()}
					</p>
					</div>
				);
			}
			
			})
		: [];
		return holder ? (
			<Row>
				<Col xs={24}>
					<p className={bemE('back')}>
						<a onClick={() => history.goBack()}>&laquo; Back</a>
					</p>
				</Col>
				{!loading ? (
					<Col xs={24}>
						<PageContentTitle>
							<Link
								to={`/directory/${clientReference}/edit`}
								className={bemE('edit-link')}
							>
								<svg
									viewBox="0 0 14 16"
									version="1.1"
									width="36"
									height="36"
								>
									<path
										fillRule="evenodd"
										fill="currentColor"
										d="M0 12v3h3l8-8-3-3-8 8zm3 2H1v-2h1v1h1v1zm10.3-9.3L12 6 9 3l1.3-1.3a.996.996 0 0 1 1.41 0l1.59 1.59c.39.39.39 1.02 0 1.41z"
									/>
								</svg>
							</Link>
							{holder.name}
						</PageContentTitle>
						<p>ID number: {holder.clientReference}</p>
						<Avatar
							image={holder.imagePath}
							className={bemE('avatar')}
						/>
						{detectables.length > 0 && (
							<h3 className={bemE('section-title')}>
								Detectables
							</h3>
						)}
						{detectables.map(item => (
							<div
								className={bemE('dt-item')}
								key={item.detectableId}
							>
								<div className={bemE('dt-name')}>
									<span className={bemE('dt-type')}>
										{item.detectableType}
									</span>{' '}
									<span className={bemE('dt-id')}>
										{item.detectableId}
									</span>
								</div>
								<div className={bemE('dt-description')}>
									{item.description}
								</div>
							</div>
						))}
						{metadata.length > 0 && (
							<h3 className={bemE('section-title')}>Metadata</h3>
						)}
						{metadata}
						{verticalConfig.attendance && (
							<React.Fragment>
								<h3 className={bemE('section-title')}>
									Schedules
								</h3>
								<ContactScheduleAssignments
									clientReference={clientReference}
								/>
							</React.Fragment>
						)}
						{sitesList &&
							sitesList.length > 0 &&
							visits &&
							visits.length > 0 && (
								<React.Fragment>
							{clientId !== 'gleneagles' && (
												<React.Fragment>
								<h3 className={bemE('section-title')}>
									Daily movement
								</h3>
								<Select
									showSearch
									style={{ width: '100%' }}
									placeholder="Select a visit"
									onChange={this.handleZoneReportChange}
								>
									{visitStartDates.map((visit, index) => (
									<Select.Option
										value={visit['value']}
										key={index}
									>
										{visit['label']}
									</Select.Option>
									))}
								</Select>
								{!loadingHolderZoneReport ? (
									holderZoneReport &&
									holderZoneReport.length > 0 && (
									<DailyMovementReport
										data={holderZoneReport}
										height='300'
									/>
									)
								) : (
									<Col xs={24}>
									<div
										style={{
										width: '100%',
										display: 'flex',
										height: '300',
										alignItems: 'center',
										justifyContent: 'center',
										}}
									>
										<Icon type="loading" style={{ fontSize: '26px' }} />
									</div>
									</Col>
								)}
							</React.Fragment>
										)}
				  {clientId !== 'gleneagles' && (
					<React.Fragment>
									<h3 className={bemE('section-title')}>
										Recent visits
									</h3>
									<Table
										columns={columns}
										dataSource={getHistory(
											visits,
											sitesList,
										)}
										scroll={{ x: 500 }}
										// size="small"
										pagination={false}
									/>
									</React.Fragment>
									)}
								</React.Fragment>
							)}
					</Col>
				) : (
					<Col xs={24}>
						<div
							style={{
								width: '100%',
								display: 'flex',
								height: 'calc(100vh - 50px)',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<Icon type="loading" style={{ fontSize: '26px' }} />
						</div>
					</Col>
				)}
			</Row>
		) : null;
	}
}

export const selector = createStructuredSelector({
	detectablesList: detectablesListSelector,
	holder: holderDetailsSelector,
	verticalConfig: verticalConfigSelector,
	loading: holderIsLoadingSelector,
	// loadingList: detectablesListIsLoadingSelector
	visits: ({ visits }) => visits.list,
	loadingVisits: ({ visits }) => visits.loading,
	sitesList: ({ sites }) => sites.list,
  holderZoneReport: ({ holderZoneReport }) => holderZoneReport.list,
  loadingHolderZoneReport: ({ holderZoneReport }) => holderZoneReport.loading
});

const mapDispatchToProps = dispatch => ({
	getHolder: params => dispatch(getHolder(params)),
	listDetectables: params => dispatch(listDetectables(params)),
  getHolderZoneReport: params => dispatch(actionsGlobal.getHolderZoneReport(params)),
	getVisitsList: params => dispatch(actionsGlobal.getVisitsList(params)),
	getSitesList: params => dispatch(actionsGlobal.getSitesList(params)),
});

export default compose(
	withRouter,
	withClientId,
	connect(
		selector,
		mapDispatchToProps,
	),
)(ContactDetails);



// WEBPACK FOOTER //
// ./src/pages/directory/contact-details/index.js